import { Swiper as SwiperCore } from 'swiper';
import { Navigation, Pagination, Scrollbar, A11y, Autoplay, Grid } from 'swiper/modules';

import './Swiper.scss';

// eslint-disable-next-line react-hooks/rules-of-hooks
SwiperCore.use([Navigation, Pagination, Scrollbar, A11y, Autoplay, Grid]);

export { Swiper } from 'swiper/react';
